import React from 'react';

import './App.css';
import HomePage from '../pages/Home/Home'

function App() {
  return (
    <HomePage />
  );
}

export default App;
